export const formatListingAddress = (listing: {
  addressLineOne?: string;
  city?: string;
  postalCode?: string;
  stateOrProvinceLongName?: string;
}): string => {
  if (listing.addressLineOne && listing.addressLineOne.length > 0) {
    return `${listing.addressLineOne}, ${listing.city}, ${listing.stateOrProvinceLongName} ${listing.postalCode}`;
  } else if (listing.city && listing.stateOrProvinceLongName) {
    const cityState = `${listing.city}, ${listing.stateOrProvinceLongName}`;
    return listing.postalCode ? `${cityState} ${listing.postalCode}` : cityState;
  } else if (listing.postalCode) {
    return `${listing.postalCode}`;
  } else {
    return '';
  }
};
